export const NEW_DAYS = 30;

export const isNewProduct = (product) => {
  if (!product?.created_at) return false;
  const age = Date.now() - new Date(product.created_at).getTime();
  return age >= 0 && age < NEW_DAYS * 24 * 60 * 60 * 1000;
};
